import axios from "@/plugins/axios";

export default {
  getRouteList(searchQuery) {
    return axios.get("/routes/types/search", {
      params: { ...searchQuery },
    });
  },
  getRoutesByCities(cityStart, cityEnd) {
    return axios.get("/routes/by-cities", {
      params: {
        city_start: cityStart,
        city_end: cityEnd,
      },
    });
  },
  getRouteCount(searchQuery) {
    return axios.get("/routes/types/count", {
      params: { ...searchQuery },
    });
  },
  getOneRoute(route_id) {
    return axios.get(`/routes/${route_id}`);
  },
  addRoute(data) {
    return axios.post("/routes", data);
  },
  updateRoute(route_id, data, cache) {
    return axios.post(`/routes/${route_id}`, { data, cache });
  },
  deleteRoute(route_id) {
    return axios.delete(`/routes/${route_id}`);
  },
  checkRouteInQuote(route_id) {
    return axios.get(`/quotes/routes/${route_id}`);
  },
};
